import { Reveal } from "./Reveal";
import { ShieldCheck } from "lucide-react";
import { EXPERIENCE, ROLE_STATEMENT, SECTORS } from "@/data/content";

const ALL_SECTORS = [...SECTORS.residential.items, ...SECTORS.commercial.items];

export const Experience = () => (
  <section id="experience" data-testid="experience" className="max-w-[1500px] mx-auto px-6 md:px-12 py-28 md:py-40">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
      <Reveal className="lg:col-span-5">
        <p className="overline text-[#d4af37] mb-6">Our Experience</p>
        <h2 className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
          Field-tested judgment, on the owner's side.
        </h2>
        <p className="mt-8 text-white/60 font-light leading-relaxed">{EXPERIENCE.body}</p>

        {/* Role clarification */}
        <div data-testid="role-statement" className="mt-10 border-l-2 border-[#d4af37] bg-white/[0.03] p-6 rounded-r-sm">
          <div className="flex items-center gap-3 mb-3">
            <ShieldCheck size={18} className="text-[#d4af37]" />
            <span className="overline text-white/70">Our Role</span>
          </div>
          <p className="text-white/70 font-light leading-relaxed text-sm">{ROLE_STATEMENT}</p>
        </div>
      </Reveal>

      <div className="lg:col-span-6 lg:col-start-7">
        {/* Measurable facts */}
        <div className="grid grid-cols-2 gap-y-12 gap-x-8 border-t border-white/10 pt-12">
          {EXPERIENCE.facts.map((f, i) => (
            <Reveal key={f.label} delay={i * 0.08}>
              <div data-testid={`experience-fact-${i}`}>
                <div className="font-serif font-light text-5xl md:text-6xl text-white leading-none tracking-tight">
                  {f.value}
                </div>
                <div className="mt-3 text-white/55 text-sm font-light leading-relaxed max-w-[240px]">
                  {f.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Sectors worked in */}
        <Reveal delay={0.1} className="mt-14">
          <p className="overline text-white/40 mb-5">{EXPERIENCE.sectorsTitle}</p>
          <div className="flex flex-wrap gap-2.5">
            {ALL_SECTORS.map((s) => (
              <span
                key={s}
                className="text-xs text-white/70 border border-white/12 rounded-full px-4 py-2 hover:border-[#d4af37]/50 hover:text-white transition-colors"
              >
                {s}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
